var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"warp"},[_c('div',{staticClass:"title"},[_vm._v("您是否要退出登录？")]),_c('div',{staticClass:"btn"},[_c('div',{staticClass:"no",on:{"click":_vm.no}},[_vm._v("否")]),_c('div',{staticClass:"yes",on:{"click":_vm.yes}},[_vm._v("是")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }